import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { StorageModule } from '@vlinder-web/storage-module-react';

import toast from 'react-hot-toast';
import { AppNavigatorService } from '@/AppNavigator';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const setPassword = async (context: any, event: any) => {
  const currentState = 'SIGN_IN_USER';
  const method = 'signIn';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.setPassword(event?.payload);
      console.log(`verifyOtp service content:`, content);
      //window.open('/profile/organization-profile', '_self');
      if (content) {
        toast.success('The password was successfully set up. Kindly log in.');
        return resolve({
          key: 'REDIRECT_SIGNIN',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'SET_PASSWORD_FAILED',
          value: {
            ...(content || {}),
          },
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('UnauthorizedError:', '');
      toast.error(_msg);
      return reject({
        key: 'SET_PASSWORD_FAILED',
        value: _msg,
      });
    }
  });
};
